import React, { useEffect, useState } from "react";
import { auth } from "../lib/firebase";
import { NavLink } from "react-router-dom";
import "../styles/Footer.css";
import MobileNav from "./MobileNav";
import logo from "../images/logo.png";
// import TranslatorWidget from "../pages/Gootranslate";
import { Phone, MapPin, Info, Globe } from "lucide-react";

const Footer = () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
    <footer className="footer">
      {!user && (
        <>
          {/* --- Top Info Section --- */}
          <div className="footer-top">
            <div className="footer-item">
              <Phone className="footer-icon" />
              <div>
                <h4>Help and Support</h4>
                <p>Find answers to your questions or reach our 24/7 support &rsaquo;</p>
              </div>
            </div>

            <div className="footer-divider" />

            <div className="footer-item">
              <MapPin className="footer-icon" />
              <div>
                <h4>International Offices</h4>
                <p>View our locations in Zurich, Geneva, Singapore, and Hong Kong &rsaquo;</p>
              </div>
            </div>

            <div className="footer-divider" />

            <div className="footer-item">
              <Info className="footer-icon" />
              <div>
                <h4>Private Banking & Offshore Services</h4>
                <p>Explore wealth management and global investment opportunities &rsaquo;</p>
              </div>
            </div>

            <div className="footer-divider" />

            <div className="footer-item">
              <Globe className="footer-icon" />
              <div>
                <h4>About Standard International Swiss Bank</h4>
                <p>Discover our heritage, leadership, and international trust network &rsaquo;</p>
              </div>
            </div>
          </div>

          {/* --- Bottom Legal Section --- */}
          <div className="footer-bottom">
            <div className="footer-bottom-inner">
              <div className="footer-logo">
                <img src={logo} alt="Bank Logo" />
              </div>
              <div className="footer-links">
                <NavLink to="/legal">Legal</NavLink>
                <NavLink to="/privacy">Privacy Notice</NavLink>
                <NavLink to="/cookies">Cookie Policy</NavLink>
                <NavLink to="/accessibility">Accessibility</NavLink>
              </div>
              <p>
                © {new Date().getFullYear()} Standard International Swiss Bank AG. All rights reserved.
              </p>
              <p>
                Operates under regulatory supervision across multiple jurisdictions.
              </p>
            </div>
          </div>
        </>
      )}

      {user && (
        <div className="mob-footer">
          <MobileNav />
        </div>
      )}

      {/* <TranslatorWidget /> */}
    </footer>
  );
};

export default Footer;
